<template>
  <div>
    <div class="flex-end" style="margin-bottom:12px">
      <button @click="$router.push('sms_send_point/create')" class="button is-primary">전송 시점 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="700"
                 @selPageLength="selPageLength">

      <div slot="package" slot-scope="props">
        {{ packageName(props.item) }}
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>

    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'SmsSendPointList',
    mixins: [
      ListMixin
    ],
    data() {
      return {
        packages: []
      }
    },
    created() {
      this.init();
      this.$axios.get('public/package').then(res => {
        if (res.status === 200) {
          this.packages = res.data;
        }
      })
    },

    methods: {
      init () {
        this.initializing('launchpack_sms_send_point', 'launchpack/sms_send_point');
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push(this.getPath("launchpack/sms_send_point/create?id=" +item.id));
        } else if (kind === "delete") {
          let value = {
            id: item.id,
            url: 'launchpack/sms_send_point/',
            title: 'sms 전송 시점을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      packageName(item) {
        let name = '';
        let data = find(this.packages, 'value', item.package)
        if(data)
          name = data.label;
        return name;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
